import { getOrCreateUsageTrackingSessionId } from "@/features/usage-tracking/usageTrackingSession";

interface LoginOptions {
  showRequestClass: string;
  showForgotPasswordClass: string;
}

/**
 * Owns the supported non-SPA interactions on the member login page.
 */
export class Login {
  private readonly opts: LoginOptions = {
    showRequestClass: "request-account",
    showForgotPasswordClass: "forgot-password",
  };

  private page: HTMLElement | null = null;
  private loginButton: HTMLElement | null = null;
  private requestAccountLink: HTMLElement | null = null;
  private backToLoginLinks: NodeListOf<HTMLElement> | null = null;
  private toggleTripLoginFormButton: HTMLElement | null = null;
  private forgotPasswordLink: HTMLElement | null = null;

  init(): void {
    this.page = document.querySelector(".login-page");
    if (!this.page) {
      return;
    }

    this.loginButton = document.getElementById("login-btn");
    this.requestAccountLink = document.getElementById("request-account-link");
    this.backToLoginLinks = document.querySelectorAll(".back-to-login-link");
    this.toggleTripLoginFormButton = document.getElementById("toggle-trip-login-form");
    this.forgotPasswordLink = document.getElementById("forgot-password-link");

    // These stable fields correlate server-side Login events with the current browser session.
    document.querySelectorAll<HTMLInputElement>(".session-id-field").forEach((field) => {
      field.value = this.getOrCreateSessionId();
    });

    this.setListeners();
  }

  getOrCreateSessionId(): string {
    return getOrCreateUsageTrackingSessionId();
  }

  private setListeners(): void {
    this.loginButton?.addEventListener("click", () => {
      this.loginButton?.classList.add("loading");
    });

    this.requestAccountLink?.addEventListener("click", (event) => {
      event.preventDefault();
      this.page?.classList.add(this.opts.showRequestClass);
    });

    this.backToLoginLinks?.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.page?.classList.remove(this.opts.showRequestClass);
        this.page?.classList.remove(this.opts.showForgotPasswordClass);
      });
    });

    this.toggleTripLoginFormButton?.addEventListener("click", (event) => {
      event.preventDefault();
      this.page?.classList.toggle("show-trip-login-form");
    });

    this.forgotPasswordLink?.addEventListener("click", (event) => {
      event.preventDefault();
      this.page?.classList.add(this.opts.showForgotPasswordClass);
    });
  }
}
